export const MissionVehicleVI = {
  "reasonMissionVehicle": {
    "column": {
      "name": "Phương tiện"
    },
    "title": "Lý do phương tiện công tác",
    "breadCrumb": "Quản lý lý do phương tiện công tác",
    "pageHeader": {
      "reasonMissionVehicle": "Quản lý lý do phương tiện công tác"
    }
  }
}
